export const spanishTranslations: Record<string, string> = {
  // Navigation
  'nav.home': 'Inicio',
  'nav.shop': 'Productos',
  'nav.about': 'Sobre nosotros',
  'nav.contact': 'Contacto',
  'nav.blog': 'Blog',
  'nav.trackOrder': 'Rastrear pedido',

  // Hero
  'hero.badge.pdrn': 'Tecnología PDRN',
  'hero.badge.glassSkin': 'Efecto Glass Skin',
  'hero.badge.korean': 'Innovación coreana',
  'hero.title': 'Cuidado facial PDRN — DNA de salmón coreano',
  'hero.subtitle': 'Transforma tu piel con sérum PDRN, mascarillas de tela y crema de cápsulas clínicamente probados. Consigue el efecto Glass Skin con productos premium de cuidado facial PDRN a base de DNA de salmón.',
  'hero.cta': 'Descubre la colección',
  'hero.ctaSurvey': 'Diagnóstico de piel gratuito',
  'hero.socialProof': 'Amado por más de 10.000 entusiastas del cuidado de la piel',
  'survey.bubbleTooltip': 'Rutina personalizada + 10 % de descuento',

  // Products
  'products.title': 'Nuestra colección',
  'products.subtitle': 'Cuidado coreano premium con tecnología PDRN',
  'products.addToCart': 'Añadir al carrito',
  'products.buyNow': 'Comprar ahora',
  'products.soldOut': 'Agotado',
  'products.save': 'Oferta',
  'products.viewDetails': 'Ver detalles',
  'products.noProducts': 'No hay productos disponibles en este momento',
  'products.selectSize': 'Selecciona tamaño',
  'products.quantity': 'Cantidad',
  'products.inStock': 'En stock',
  'products.outOfStock': 'Agotado',

  // Upsell
  'upsell.title': 'Completa tu rutina',
  'upsell.savings': 'Ahorra con el set completo',
  'upsell.cta': 'Mejora al set completo',
  'upsell.includes': 'Rutina completa de cuidado facial en un solo paquete',
  'upsell.badge': 'Completa tu rutina',
  'upsell.saveBadge': '¡Ahorra {amount}!',
  'upsell.whyBundle': '¿Por qué elegir el set completo?',
  'upsell.whyBundleDesc': 'Cada paso potencia al anterior para resultados máximos',
  'upsell.includesSerum': 'Sérum de brillo rosa',
  'upsell.includesCream': 'Crema de cápsulas inteligente',
  'upsell.includesMasks': 'Pack de 10 mascarillas',
  'upsell.separatelyPrice': 'Por separado: {amount}',
  'upsell.serumTooltip': 'Sérum ligero PDRN que estimula la producción de colágeno, suaviza arrugas y proporciona un brillo Glass Skin instantáneo.',
  'upsell.creamTooltip': 'Fórmula innovadora de cápsulas con PDRN, 5 % de niacinamida y colágeno hidrolizado para una hidratación profunda y firmeza.',
  'upsell.masksTooltip': '10 mascarillas de tela empapadas en sérum concentrado PDRN para un tratamiento intensivo que proporciona un efecto Glass Skin instantáneo.',

  // Cart
  'cart.title': 'Carrito de compra',
  'cart.empty': 'Tu carrito está vacío',
  'cart.itemCount': '{count} artículos en el carrito',
  'cart.total': 'Total',
  'cart.checkout': 'Ir a pagar',
  'cart.continueShopping': 'Seguir comprando',
  'cart.addedToCart': '¡Añadido al carrito!',
  'cart.couponPlaceholder': 'Código de descuento',
  'cart.applyCoupon': 'Aplicar',
  'cart.couponApplied': '¡Descuento aplicado!',
  'cart.couponError': 'Código no válido',
  'cart.removeCoupon': 'Eliminar',
  'cart.freeShippingUnlocked': '¡Has conseguido envío gratuito!',
  'cart.freeShippingRemaining': 'Añade {amount} más para envío gratuito',
  'cart.freeShippingThreshold': 'Envío gratuito en pedidos superiores a {amount}',
  'cart.completeRoutine': 'Completa tu rutina',
  'cart.bundleSave': 'Ahorra {percent}%',
  'cart.quickAdd': 'Añadir',

  'promo.b2g1': '🎁 ¡Añade 3 artículos al carrito — 1 es GRATIS!',
  'promo.b2g1Cart': '🎁 ¡Oferta 2+1 aplicada! ¡Por cada 3 artículos, 1 es GRATIS!',
  'promo.b2g1CartHint': '¡Añade {count} más para obtener un producto GRATIS! (se necesitan 3)',
  'promo.b2g1Saving': '¡Ahorras {amount} — el artículo más barato es GRATIS!',
  'promo.freeItem': '🎁 GRATIS en promoción',

  // About
  'about.title': 'Sobre nosotros',
  'about.subtitle': 'La ciencia detrás de la belleza coreana',
  'about.pdrnTitle': 'La ciencia del cuidado facial PDRN',
  'about.pdrnDescription': 'PDRN (polideoxirribonucleótido) se extrae del DNA de salmón — un ingrediente revolucionario en el cuidado coreano de la piel. Nuestros productos PDRN estimulan la renovación celular para un efecto Glass Skin perfecto.',
  'about.glassSkinDesc': 'Consigue el codiciado efecto Glass Skin coreano con un brillo instantáneo.',
  'about.hydrationDesc': 'Hidratación profunda que dura todo el día, con retención de humedad clínicamente probada.',
  'about.antiAgingDesc': 'Estimula la producción de colágeno de forma natural para una piel más firme y joven.',

  // Footer
  'footer.copyright': '© 2026 PDRN SKIN. Todos los derechos reservados.',
  'footer.freeShipping': 'Envío gratuito a partir de {amount} (España)',
  'footer.securePayment': 'Pago seguro',
  'footer.support': 'Atención al cliente 24/7',
  'footer.description': 'Cuidado coreano premium con tecnología PDRN revolucionaria. Experimenta el efecto Glass Skin con nuestros productos científicos.',
  'footer.sheetMasks': 'Mascarillas de tela',
  'footer.serum': 'Sérum',
  'footer.cream': 'Crema',
  'footer.bundle': 'Set completo',
  'footer.faq': 'Preguntas frecuentes',
  'footer.shippingReturns': 'Envíos y devoluciones',
  'footer.privacyPolicy': 'Política de privacidad',
  'footer.termsOfService': 'Términos de uso',
  'footer.returnPolicy': 'Política de devoluciones',
  'footer.contactSupport': 'Estamos aquí para ti — preguntas, estado de pedido, problemas o ayuda con una compra. Contacta con nuestro servicio al cliente en',

  // Common
  'common.verified': 'Verificado',
  'common.before': 'Antes',
  'common.after': 'Después',
  'common.loading': 'Cargando...',
  'common.error': 'Se produjo un error',
  'common.noPhotoShared': 'La clienta no compartió foto',

  // Media
  'media.videoPlaceholder': 'Marcador de vídeo',
  'media.gifPlaceholder': 'Marcador de GIF',
  'media.imagePlaceholder': 'Marcador de imagen',

  // Feature
  'feature.hydration': '+100 % hidratación',
  'feature.glassSkin': 'Efecto Glass Skin',
  'feature.antiAging': 'Antiedad',
  'feature.collagen': 'Boost de colágeno',
  'feature.brightening': 'Iluminación',

  // Product
  'product.howToUse': 'Modo de uso',
  'product.ingredients': 'Ingredientes clave',
  'product.reviews': 'Opiniones de clientas',
  'product.results': 'Resultados reales',
  'product.realResults': 'Resultados reales',
  'product.beforeAfter': 'Antes y después',
  'product.faqTitle': 'Preguntas y respuestas',
  'product.mediaGallery': 'Galería de medios',
  'product.freeShipping': 'Envío gratuito desde {amount}',
  'product.secureCheckout': 'Pago seguro',
  'product.returns': 'Devolución en 7 días',
  'product.koreanFormula': 'Fórmula coreana',
  'product.premiumIngredients': 'Ingredientes premium',
  'product.backHome': 'Volver a la página principal',
  'product.notFound': 'Producto no encontrado',
  'product.bestValue': 'Mejor precio',
  'product.bestseller': 'Más vendido',
  'product.reviewCount': '({count} opiniones)',
  'product.crueltyFree': 'No testado en animales',
  'product.youMayAlsoLike': 'También te puede gustar',
  'product.completeRoutine': 'Completa tu rutina de cuidado facial',
  'product.moneyBack': 'Devolución del dinero en 7 días',
  'product.dermatologistTested': 'Testado dermatológicamente',
  'product.payWith': 'Pago seguro con',
  'product.specsTitle': 'Detalles del producto',
  'product.specsVolume': 'Tamaño',
  'product.specsSkinType': 'Tipo de piel',
  'product.specsTested': 'Pruebas',
  'product.specsClinicallyTested': 'Clínicamente testado',
  'product.specsShelfLife': 'Vida útil',
  'product.specsFreeOf': 'Sin parabenos, sulfatos ni ftalatos',
  'product.satisfactionGuarantee': 'Garantía de satisfacción al 100 %',
  'product.satisfactionDesc': 'Prueba sin riesgo con nuestra garantía de devolución del dinero en 7 días',

  // Before & After
  'beforeAfter.customer1': 'Lucía',
  'beforeAfter.customer2': 'Priya',
  'beforeAfter.customer3': 'Amara',
  'beforeAfter.weeks3': '3 semanas de uso',
  'beforeAfter.weeks8': '8 semanas de uso',
  'beforeAfter.weeks12': '12 semanas de uso',

  // Mobile Cart
  'mobileCart.findRoutine': 'Encuentra tu rutina',

  // Survey
  'survey.buttonText': 'Encuentra tu rutina',
  'survey.title': 'Diagnóstico de piel',
  'survey.subtitle': 'Responde unas preguntas cortas y te encontraré la rutina perfecta',
  'survey.question': 'Pregunta',
  'survey.back': 'Atrás',
  'survey.next': 'Siguiente',
  'survey.getResults': 'Ver resultados',
  'survey.resultsTitle': 'La rutina que he diseñado para ti',
  'survey.resultsSubtitle': 'Según lo que me has contado, esto es lo que te recomiendo',
  'survey.yourProfile': 'Tu perfil de piel',
  'survey.recommended': 'Recomendado para ti',
  'survey.bundleNote': 'Para los mejores resultados, te recomiendo el set completo',
  'survey.howToUse': 'La rutina que he diseñado para ti',
  'survey.morning': 'Mañana',
  'survey.evening': 'Noche',
  'survey.expectedResults': 'Resultados esperados',
  'survey.week': 'Semana',
  'survey.weeks': 'Semanas',
  'survey.personalTips': 'Mis consejos para ti',
  'survey.retake': 'Repetir',
  'survey.shopNow': 'Comprar ahora',
  'survey.errorTooMany': 'Demasiadas solicitudes. Inténtalo de nuevo más tarde.',
  'survey.errorGeneric': 'Algo salió mal. Inténtalo de nuevo.',
  'survey.yourPersonalizedRoutine': 'La rutina que he diseñado para ti',
  'survey.treatmentPlan': 'Duración de tratamiento recomendada',
  'survey.addRoutineToCart': 'Añadir la rutina al carrito',
  'survey.satisfactionGuarantee': 'Garantía de satisfacción al 100 %',
  'survey.maybeLater': 'Quizás más tarde',
  'survey.continueSurvey': 'Continuar con el cuestionario',
  'survey.addedToCart': '¡Los productos se han añadido al carrito!',
  'survey.personalizedRoutine': 'Tu rutina personalizada está lista',
  'survey.errorAddingToCart': 'Error al añadir al carrito',
  'survey.exclusiveDiscount': '¡10 % de descuento exclusivo para ti!',
  'survey.couponCopied': '¡Código de cupón copiado!',
  'survey.useAtCheckout': 'Usa el código SURVEY10 en el pago para obtener un 10 % de descuento',
  'survey.bestDeal': '¡La mejor oferta que he encontrado para ti!',
  'survey.separatePrice': 'Por separado',
  'survey.yourPrice': 'Tu precio',
  'survey.youSave': 'Te ahorras',
  'survey.upgradeOption': '¿Quieres resultados aún mejores?',
  'survey.upgradeToBundle': 'Mejora a la rutina completa',
  'survey.upgradeSave': 'Ahorra {amount} con el set completo',
  'survey.addSingleToCart': 'Añadir al carrito',

  // Survey loading messages
  'survey.loading.analyzing': 'Analizando tu perfil de piel...',
  'survey.loading.planning': 'Diseñando un tratamiento personalizado...',
  'survey.loading.matching': 'Encontrando los productos perfectos para ti...',
  'survey.loading.finalizing': 'Casi listo...',

  // Survey questions
  'survey.q1.question': '¿Cuál es tu tipo de piel?',
  'survey.q1.dry': 'Seca — mi piel se siente tirante a menudo',
  'survey.q1.oily': 'Grasa — brillante, sobre todo en la frente y la nariz',
  'survey.q1.combination': 'Mixta — frente y nariz grasas, mejillas secas',
  'survey.q1.normal': 'Normal — equilibrada, sin problemas significativos',
  'survey.q2.question': '¿Qué es lo que más te preocupa de tu piel?',
  'survey.q2.aging': 'Arrugas y líneas de expresión',
  'survey.q2.acne': 'Acné e imperfecciones',
  'survey.q2.dullness': 'Piel apagada y tono desigual',
  'survey.q2.hyperpigmentation': 'Manchas oscuras e hiperpigmentación',
  'survey.q3.question': '¿Qué tan sensible es tu piel?',
  'survey.q3.very': 'Muy sensible — reacciona a la mayoría de los productos',
  'survey.q3.somewhat': 'Algo sensible — reacciones ocasionales',
  'survey.q3.not': 'No sensible — tolera la mayoría de los productos',
  'survey.q4.question': '¿Cuánta hidratación tiene tu piel?',
  'survey.q4.veryDry': 'Muy seca — necesita hidratación constantemente',
  'survey.q4.somewhatDry': 'Un poco seca — necesita hidratación regularmente',
  'survey.q4.balanced': 'Equilibrada — ni seca ni grasa',
  'survey.q4.wellHydrated': 'Bien hidratada — firme y saludable',
  'survey.q5.question': '¿Cuál es tu rango de edad?',
  'survey.q5.under25': 'Menor de 25',
  'survey.q5.25to35': '25–35',
  'survey.q5.35to45': '35–45',
  'survey.q5.over45': 'Mayor de 45',
  'survey.q6.question': '¿Cómo describirías tu rutina actual de cuidado de la piel?',
  'survey.q6.minimal': 'Mínima — solo limpieza e hidratación',
  'survey.q6.basic': 'Básica — limpieza, tónico, hidratación',
  'survey.q6.moderate': 'Moderada — incluye sérums y tratamientos',
  'survey.q6.extensive': 'Completa — rutina completa de cuidado coreano',
  'survey.q7.question': '¿Cómo describirías la textura de tu piel?',
  'survey.q7.smooth': 'Suave y uniforme',
  'survey.q7.rough': 'Áspera y con textura',
  'survey.q7.uneven': 'Irregular con algunas imperfecciones',
  'survey.q7.bumpy': 'Rugosa con poros visibles',
  'survey.q8.question': '¿Cuál es tu objetivo principal con el cuidado de la piel?',
  'survey.q8.glow': 'Conseguir el brillo coreano',
  'survey.q8.antiAging': 'Reducir los signos de envejecimiento',
  'survey.q8.hydration': 'Hidratación profunda',
  'survey.q8.all': 'Todo lo anterior',

  // Trust Strip
  'trust.clinicallyTested': 'Clínicamente testado',
  'trust.happyCustomers': 'Más de 10.000 clientas satisfechas',
  'trust.labFormula': 'Fórmula de laboratorio coreano',
  'trust.moneyBack': 'Devolución del dinero en 7 días',

  // Science
  'science.title': 'PDRN de DNA de salmón — respaldado por la ciencia',
  'science.subtitle': 'PDRN está clínicamente probado con estudios revisados por pares',
  'science.citation1': '"PDRN promueve la cicatrización de heridas y la regeneración tisular mediante la activación del receptor de adenosina A2A."',
  'science.source1': '— Journal of Cosmetic Dermatology, 2020',
  'science.citation2': '"PDRN de origen salmón mejora significativamente la hidratación, la elasticidad y reduce la profundidad de las arrugas en ensayos clínicos."',
  'science.source2': '— International Journal of Molecular Sciences, 2021',

  // Science Inside
  'scienceInside.title': 'La ciencia por dentro',
  'scienceInside.subtitle': 'Por qué esta fórmula funciona — dos potentes motores en un solo sérum',
  'scienceInside.peptides.title': 'Péptidos — Los ingenieros',
  'scienceInside.peptides.subtitle': '"Mensajeros inteligentes, no una crema mágica"',
  'scienceInside.peptides.point1': 'Cadenas cortas de aminoácidos que indican a tu piel que se comporte como una piel joven y renovada',
  'scienceInside.peptides.point2': 'Favorecen un aspecto más firme y líneas finas menos visibles con el tiempo',
  'scienceInside.peptides.point3': 'Refuerzan la barrera cutánea — la piel se siente menos «frágil» y menos reactiva',
  'scienceInside.peptides.point4': 'Efecto inteligente que se intensifica con el uso constante, no un milagro de un día',
  'scienceInside.pdrn.title': 'PDRN — El reparador',
  'scienceInside.pdrn.subtitle': 'El ingrediente reparador líder en el mundo del K-Beauty',
  'scienceInside.pdrn.point1': 'Fragmentos de DNA que hablan el idioma de la renovación y la reparación',
  'scienceInside.pdrn.point2': 'Favorece la calidad de la piel y promueve un aspecto saludable y más denso',
  'scienceInside.pdrn.point3': 'Calmante para la piel estresada o reactiva — menos rojez, más equilibrio',
  'scienceInside.pdrn.point4': 'En el sérum: mejora constante e inteligente — no dramática de la noche a la mañana',
  'scienceInside.combo.title': 'Dos motores, un sérum',
  'scienceInside.combo.subtitle': 'Brillo instantáneo + antiedad acumulativo',
  'scienceInside.combo.point1': 'Motor 1: "Velo ahora" — hidratación, dispersión de la luz, textura más suave',
  'scienceInside.combo.point2': 'Motor 2: "Velo con el tiempo" — firmeza, elasticidad, reparación',
  'scienceInside.combo.point3': 'El efecto "wow" inmediato te motiva a continuar — los péptidos y el PDRN hacen el resto',
  'scienceInside.combo.point4': 'El resultado: piel que se ve densa, calmada y pulida',
  'scienceInside.tagline': 'Los péptidos construyen y refuerzan. El PDRN repara y calma. Juntos, le dan a tu piel brillo instantáneo y renovación a largo plazo.',

  // Science Inside — Default
  'scienceInside.default.subtitle': 'La ciencia detrás del PDRN — cómo transforma tu piel desde dentro',
  'scienceInside.default.tagline': 'PDRN activa el mecanismo de reparación natural de la piel, promueve la renovación celular y una hidratación profunda desde el primer uso.',

  // Default product FAQ
  'productContent.default.faq1.q': '¿Qué es PDRN y cómo funciona?',
  'productContent.default.faq1.a': 'PDRN (polideoxirribonucleótido) se extrae del DNA de salmón. Activa el mecanismo de reparación natural de la piel a través del receptor de adenosina A2A, y promueve la renovación celular, la producción de colágeno y la hidratación profunda.',
  'productContent.default.faq2.q': '¿Es el producto adecuado para pieles sensibles?',
  'productContent.default.faq2.a': '¡Sí! Nuestras fórmulas están testadas dermatológicamente, son cruelty-free y están libres de parabenos, sulfatos y ftalatos. Están diseñadas para ser suaves con todo tipo de pieles, incluidas las sensibles.',
  'productContent.default.faq3.q': '¿Cuánto tiempo tarda en verse los resultados?',
  'productContent.default.faq3.a': 'La mayoría de las usuarias notan una hidratación mejorada y un brillo visible desde el primer uso. Para resultados óptimos en líneas de expresión y textura de la piel, se recomienda un uso constante de 4 a 8 semanas.',

  // Science Inside — Masks
  'scienceInside.masks.subtitle': 'Cómo tres ingredientes potentes trabajan juntos en cada mascarilla de tela',
  'scienceInside.masks.tagline': 'PDRN repara a nivel celular. Vitamina B12 ilumina. Niacinamida refuerza. 20 minutos — es todo lo que tu piel necesita para absorberlo todo.',
  'scienceInside.masks.card1.title': 'PDRN + Vitamina B12 — El dúo iluminador',
  'scienceInside.masks.card1.subtitle': 'Reparación celular se encuentra con brillo visible',
  'scienceInside.masks.card1.point1': 'PDRN activa la renovación celular mientras Vitamina B12 proporciona un efecto iluminador instantáneo',
  'scienceInside.masks.card1.point2': 'Juntos tratan la piel apagada desde la raíz — no solo brillo superficial',
  'scienceInside.masks.card1.point3': 'B12 es un ingrediente de cuidado de la piel probado que unifica el tono con el tiempo',
  'scienceInside.masks.card1.point4': 'El dúo funciona en sinergia — PDRN renueva, B12 ilumina',
  'scienceInside.masks.card2.title': 'Niacinamida — La constructora de barreras',
  'scienceInside.masks.card2.subtitle': 'Refuerza, equilibra, protege',
  'scienceInside.masks.card2.point1': 'Refuerza la barrera cutánea para retener la hidratación e impedir la entrada de irritantes',
  'scienceInside.masks.card2.point2': 'Reduce visiblemente los poros y regula el exceso de sebo',
  'scienceInside.masks.card2.point3': 'Reduce la rojez y calma la inflamación — ideal para pieles sensibles',
  'scienceInside.masks.card2.point4': 'Actúa en todas las capas de la piel para mejorar textura, tono y resistencia',
  'scienceInside.masks.card3.title': 'El efecto mascarilla — 20 minutos de absorción profunda',
  'scienceInside.masks.card3.subtitle': 'Por qué una mascarilla de tela es mejor que un sérum normal',
  'scienceInside.masks.card3.point1': 'La mascarilla de tela crea un entorno oclusivo que evita la evaporación',
  'scienceInside.masks.card3.point2': 'Los ingredientes activos se entregan en mayor concentración que los sérums diarios',
  'scienceInside.masks.card3.point3': 'Absorción profunda — los ingredientes penetran más gracias al contacto prolongado con la piel',
  'scienceInside.masks.card3.point4': 'Resultados inmediatos y visibles: piel más jugosa, más hidratada y con brillo desde el primer uso',

  // Science Inside — Cream
  'scienceInside.cream.subtitle': 'Tres tecnologías avanzadas que trabajan por la noche para transformar tu piel',
  'scienceInside.cream.tagline': 'El colágeno reconstruye la estructura. Las ceramidas protegen la barrera. Las cápsulas inteligentes lo entregan todo durante la noche — para que despiertes con piel renovada y firme.',
  'scienceInside.cream.card1.title': 'Colágeno hidrolizado — La estructura',
  'scienceInside.cream.card1.subtitle': 'Reconstrucción desde dentro hacia fuera',
  'scienceInside.cream.card1.point1': 'Fragmentado en trozos pequeños que realmente pueden penetrar en la piel — no solo quedarse en la superficie',
  'scienceInside.cream.card1.point2': 'Apoya la matriz estructural de la piel para una firmeza y elasticidad mejoradas',
  'scienceInside.cream.card1.point3': 'Ayuda a reducir la apariencia de las líneas finas rellenando desde dentro',
  'scienceInside.cream.card1.point4': 'Trabaja con la producción natural de colágeno de tu piel — refuerza, no reemplaza',
  'scienceInside.cream.card2.title': 'Complejo de ceramidas — El protector',
  'scienceInside.cream.card2.subtitle': 'La protección natural de tu piel, reforzada',
  'scienceInside.cream.card2.point1': 'Las ceramidas constituyen el 50 % de la barrera natural de la piel — reponemos lo que se pierde con la edad',
  'scienceInside.cream.card2.point2': 'Retiene la hidratación hasta 72 horas — sin más sequedad ni tirantez por la noche',
  'scienceInside.cream.card2.point3': 'Protege contra daños ambientales: contaminación, aire seco, cambios de temperatura',
  'scienceInside.cream.card2.point4': 'Refuerza la barrera para que otros ingredientes activos funcionen de forma más efectiva',
  'scienceInside.cream.card3.title': 'Tecnología de cápsulas inteligentes — Liberación gradual',
  'scienceInside.cream.card3.subtitle': 'Ingredientes activos entregados durante toda la noche',
  'scienceInside.cream.card3.point1': 'Microcápsulas se descomponen gradualmente y liberan ingredientes activos durante 8 horas',
  'scienceInside.cream.card3.point2': 'Evita la degradación de los ingredientes — permanecen potentes hasta el momento de su liberación',
  'scienceInside.cream.card3.point3': 'Tu piel recibe un flujo constante de nutrición en lugar de una dosis grande que se desvanece',
  'scienceInside.cream.card3.point4': 'Despierta con piel renovada e hidratada — las cápsulas han trabajado mientras dormías',

  // Science Inside — Bundle
  'scienceInside.bundle.subtitle': 'Por qué tres productos juntos ofrecen resultados que ningún producto individual puede lograr',
  'scienceInside.bundle.tagline': 'Las mascarillas limpian y nutren. El sérum repara e ilumina. La crema sella todo dentro. Tres pasos, un sistema — 24 horas de transformación continua de la piel.',
  'scienceInside.bundle.card1.title': 'Tres pasos, un sistema',
  'scienceInside.bundle.card1.subtitle': 'Cada producto prepara la piel para el siguiente paso',
  'scienceInside.bundle.card1.point1': 'Paso 1: Las mascarillas de tela limpian en profundidad y nutren con PDRN concentrado + Vitamina B12',
  'scienceInside.bundle.card1.point2': 'Paso 2: El sérum repara, reafirma y proporciona el efecto Glass Skin',
  'scienceInside.bundle.card1.point3': 'Paso 3: La crema sella todo con colágeno, ceramidas y cápsulas de liberación gradual',
  'scienceInside.bundle.card1.point4': 'Juntos: una rutina completa donde cada paso potencia al anterior',
  'scienceInside.bundle.card2.title': 'El efecto sinergia — Mejor juntos',
  'scienceInside.bundle.card2.subtitle': 'Resultados acumulativos que se intensifican con el tiempo',
  'scienceInside.bundle.card2.point1': 'Usar los tres productos crea un efecto acumulativo — los resultados se construyen unos sobre otros',
  'scienceInside.bundle.card2.point2': 'PDRN en cada paso significa renovación celular constante a lo largo de toda la rutina',
  'scienceInside.bundle.card2.point3': 'Diferentes métodos de entrega (mascarilla, sérum, crema) aseguran que los ingredientes lleguen a todas las capas de la piel',
  'scienceInside.bundle.card2.point4': 'Las clientas reportan resultados significativamente más rápidos con la rutina completa',
  'scienceInside.bundle.card3.title': 'Cobertura 24 horas — Día y noche',
  'scienceInside.bundle.card3.subtitle': 'Tu piel nunca queda desprotegida',
  'scienceInside.bundle.card3.point1': 'Mañana: Sérum bajo el maquillaje para hidratación, protección y brillo durante todo el día',
  'scienceInside.bundle.card3.point2': 'Noche: Mascarilla de tela para limpieza profunda y nutrición (2–3 veces por semana)',
  'scienceInside.bundle.card3.point3': 'Noche: Crema con cápsulas de liberación gradual que trabajan mientras duermes',
  'scienceInside.bundle.card3.point4': 'El resultado: renovación las 24 horas — tu piel mejora 24/7',

  // What is PDRN
  'whatIsPDRN.title': '¿Qué es PDRN?',
  'whatIsPDRN.subtitle': 'El ingrediente revolucionario que está cambiando el mundo del cuidado de la piel — de la clínica a tu hogar',
  'whatIsPDRN.origin.title': 'Extraído del DNA de salmón',
  'whatIsPDRN.origin.subtitle': 'Un ingrediente probado en medicina estética',
  'whatIsPDRN.origin.point1': 'PDRN (polideoxirribonucleótido) se extrae del DNA de salmón — una molécula biocompatible utilizada en clínicas dermatológicas de todo el mundo',
  'whatIsPDRN.origin.point1.US': 'PDRN (polideoxirribonucleótido) se extrae del DNA de salmón — una molécula biocompatible utilizada en clínicas dermatológicas de todo Estados Unidos',
  'whatIsPDRN.origin.point1.GB': 'PDRN (polideoxirribonucleótido) se extrae del DNA de salmón — una molécula biocompatible utilizada en clínicas dermatológicas de todo el Reino Unido',
  'whatIsPDRN.origin.point1.AU': 'PDRN (polideoxirribonucleótido) se extrae del DNA de salmón — una molécula biocompatible utilizada en clínicas dermatológicas de toda Australia',
  'whatIsPDRN.origin.point1.IL': 'PDRN (polideoxirribonucleótido) se extrae del DNA de salmón — una molécula biocompatible utilizada en clínicas dermatológicas de todo Israel',
  'whatIsPDRN.origin.point1.ES': 'PDRN (polideoxirribonucleótido) se extrae del DNA de salmón — una molécula biocompatible utilizada en clínicas dermatológicas de toda España',
  'whatIsPDRN.origin.point1.FR': 'PDRN (polideoxirribonucleótido) se extrae del DNA de salmón — una molécula biocompatible utilizada en clínicas dermatológicas de toda Francia',
  'whatIsPDRN.origin.point1.DE': 'PDRN (polideoxirribonucleótido) se extrae del DNA de salmón — una molécula biocompatible utilizada en clínicas dermatológicas de toda Alemania',
  'whatIsPDRN.origin.point1.NO': 'PDRN (polideoxirribonucleótido) se extrae del DNA de salmón — una molécula biocompatible utilizada en clínicas dermatológicas de toda Noruega',
  'whatIsPDRN.origin.point1.HR': 'PDRN (polideoxirribonucleótido) se extrae del DNA de salmón — una molécula biocompatible utilizada en clínicas dermatológicas de toda Croacia',
  'whatIsPDRN.origin.point1.FI': 'PDRN (polideoxirribonucleótido) se extrae del DNA de salmón — una molécula biocompatible utilizada en clínicas dermatológicas de toda Finlandia',
  'whatIsPDRN.origin.point1.AE': 'PDRN (polideoxirribonucleótido) se extrae del DNA de salmón — una molécula biocompatible utilizada en clínicas dermatológicas de todos los EAU',
  'whatIsPDRN.origin.point2': 'Respaldado por estudios clínicos con resultados medibles en hidratación y elasticidad',
  'whatIsPDRN.origin.point3': 'Compuesto regenerativo natural — sin rellenos sintéticos, sin químicos agresivos',
  'whatIsPDRN.howItWorks.title': 'Regeneración a nivel celular',
  'whatIsPDRN.howItWorks.subtitle': 'Actúa donde otros productos no llegan',
  'whatIsPDRN.howItWorks.point1': 'Activa el receptor de adenosina A2A — desencadena el proceso natural de reparación y renovación de tu piel',
  'whatIsPDRN.howItWorks.point2': 'Estimula la producción de colágeno y elastina desde dentro, no solo hidratación superficial',
  'whatIsPDRN.howItWorks.point3': 'Reduce la inflamación y calma la piel estresada para una piel más sana y equilibrada',
  'whatIsPDRN.results.title': 'Resultados clínicos en casa',
  'whatIsPDRN.results.subtitle': 'Hasta hace poco — solo en clínicas',
  'whatIsPDRN.results.point1': 'Hasta hace poco, los tratamientos con PDRN solo estaban disponibles en clínicas dermatológicas exclusivas a precios elevados',
  'whatIsPDRN.results.point2': 'Nuestras fórmulas ofrecen el mismo ingrediente activo en un formato de uso diario que puedes aplicar en casa',
  'whatIsPDRN.results.point3': '+100 % de mejora en hidratación medida clínicamente — mejora visible desde la primera aplicación',

  // Proven Results
  'provenResults.title': 'Resultados probados',
  'provenResults.stat1.value': '+100 %',
  'provenResults.stat1.label': 'Mejora en hidratación',
  'provenResults.stat1.sub': 'Medido clínicamente',
  'provenResults.stat2.value': '93 %',
  'provenResults.stat2.label': 'Piel más suave',
  'provenResults.stat2.sub': 'Reportado en 4 semanas',
  'provenResults.stat3.value': '4.9/5',
  'provenResults.stat3.label': 'Valoración de clientas',
  'provenResults.stat3.sub': 'Promedio de todos los productos',
  'provenResults.stat4.value': '+10.000',
  'provenResults.stat4.label': 'Clientas satisfechas',
  'provenResults.stat4.sub': 'En todo el mundo',
  'provenResults.stat4.sub.US': 'En todo Estados Unidos',
  'provenResults.stat4.sub.GB': 'En todo el Reino Unido',
  'provenResults.stat4.sub.AU': 'En toda Australia',
  'provenResults.stat4.sub.IL': 'En todo Israel',
  'provenResults.stat4.sub.ES': 'En toda España',
  'provenResults.stat4.sub.FR': 'En toda Francia',
  'provenResults.stat4.sub.DE': 'En toda Alemania',
  'provenResults.stat4.sub.NO': 'En toda Noruega',
  'provenResults.stat4.sub.HR': 'En toda Croacia',
  'provenResults.stat4.sub.FI': 'En toda Finlandia',
  'provenResults.stat4.sub.AE': 'En todos los EAU',

  // Comparison Table
  'comparison.title': 'PDRN frente al cuidado convencional',
  'comparison.headerRegular': 'Cuidado convencional',
  'comparison.headerPDRN': 'PDRN SKIN',
  'comparison.row1.criteria': 'Acción',
  'comparison.row1.regular': 'Hidratación superficial',
  'comparison.row1.pdrn': 'Regeneración a nivel celular',
  'comparison.row2.criteria': 'Ingrediente activo',
  'comparison.row2.regular': 'Péptidos genéricos',
  'comparison.row2.pdrn': 'PDRN (DNA de salmón)',
  'comparison.row3.criteria': 'Resultados',
  'comparison.row3.regular': 'Semanas hasta verlo',
  'comparison.row3.pdrn': 'Visible desde el primer uso',
  'comparison.row4.criteria': 'Tecnología',
  'comparison.row4.regular': 'Fórmulas convencionales',
  'comparison.row4.pdrn': 'Tecnología de nivel clínico',
  'comparison.row5.criteria': 'Evidencia clínica',
  'comparison.row5.regular': 'Afirmaciones de marketing',
  'comparison.row5.pdrn': 'Clínicamente testado +100 % hidratación',

  // FAQ
  'faq.sectionTitle': 'Preguntas frecuentes',

  // 404
  '404.title': 'Página no encontrada',
  '404.subtitle': 'La página que buscas no existe o ha sido movida.',
  '404.backHome': 'Volver a la página principal',
  '404.popularProducts': 'Productos populares',

  // Product Disclaimer & Misc
  'product.disclaimer': '*Las imágenes son solo con fines ilustrativos. Los resultados pueden variar de una persona a otra según el tipo de piel y el uso. El producto no está destinado al diagnóstico, tratamiento o prevención de condiciones médicas. Se recomienda realizar una prueba de sensibilidad en una zona oculta antes del primer uso completo. En caso de sensibilidad, deje de usarlo. En caso de sensibilidad grave, consulte a un médico. El proveedor puede cambiar el embalaje y la forma del producto de vez en cuando; el producto es el mismo.',
  'product.shippingMarquee': 'Envío gratuito en pedidos superiores a {amount} en toda España',
  'product.inStockReady': 'En stock y listo para envío inmediato',

  // Terms agreement
  'product.termsAgreementBefore': 'Al navegar y comprar en este sitio aceptas los ',
  'product.termsLink': 'términos de uso',
  'product.termsAgreementAfter': '',

  // Announcement
  'announcement.freeShipping': '✨ Envío gratuito en pedidos superiores a {amount} en toda España',
  'announcement.close': 'Cerrar',
  'urgency.limitedOffer': 'Oferta limitada',
  'urgency.endsIn': 'Termina en',

  // Blog
  'blog.title': 'Blog',
  'blog.subtitle': 'Guías profesionales de cuidado de la piel, ciencia PDRN y consejos del cuidado coreano',
  'blog.metaDescription': 'Lee nuestras guías profesionales sobre cuidado PDRN, ciencia del DNA de salmón, rutinas Glass Skin y consejos del cuidado coreano.',
  'blog.readMore': 'Leer más',
  'blog.minRead': 'min de lectura',
  'blog.badge': 'Cuidado respaldado por la ciencia',
  'blog.chip.antiAging': 'Antiedad',
  'blog.chip.hydration': 'Hidratación',
  'blog.chip.sensitiveSkin': 'Piel sensible',
  'blog.chip.nightRoutine': 'Rutina nocturna',
  'blog.chip.ingredients': 'Ingredientes',
  'blog.chip.layering': 'Layering',
  'blog.chip.glassSkin': 'Glass Skin',
  'blog.chip.pdrnScience': 'Ciencia del PDRN',
  'blog.relatedArticles': 'Artículos relacionados',
  'blog.recommendedProducts': 'Productos recomendados',
  'blog.latestArticles': 'Lo último en nuestro blog',
  'blog.latestSubtitle': 'Guías profesionales de cuidado PDRN y consejos del cuidado coreano',
  'blog.viewAll': 'Ver todos los artículos',
  'blog.statsArticles': 'Artículos',
  'blog.statsLanguages': 'Idiomas',
  'blog.statsVersions': 'Versiones traducidas',
  'blog.availableIn': 'Disponible en 11 idiomas',
  'blog.avgReadTime': 'Prom. 5 min de lectura',

  // SEO meta (homepage)
  'seo.homeTitle': 'PDRN Cuidado Facial | Sérum ADN de Salmón Coreano, Mascarillas & Crema | Glass Skin',
  'seo.homeDescription': 'Cuidado facial PDRN con tecnología de ADN de salmón coreano. Sérum PDRN, mascarillas y crema cápsula para el efecto Glass Skin. Clínicamente probado con envío gratuito.',

  // SEO product titles & descriptions
  'seo.productTitle.pink-glow-serum-with-pdrn-peptides': 'Sérum PDRN con ADN de Salmón y Péptidos | Cuidado Facial PDRN',
  'seo.productDescription.pink-glow-serum-with-pdrn-peptides': 'Compra el sérum PDRN con ADN de salmón y péptidos. Sérum coreano Glass Skin que estimula el colágeno y alisa las arrugas. Envío gratuito.',
  'seo.productTitle.pdrn-pink-sheet-masks-10-pack': 'Mascarillas PDRN Pack de 10 | Mascarillas Coreanas ADN de Salmón | PDRN',
  'seo.productDescription.pdrn-pink-sheet-masks-10-pack': 'Compra mascarillas de tejido PDRN bañadas en sérum de ADN de salmón. 10 mascarillas coreanas para el efecto Glass Skin con PDRN, Vitamina B12 y Niacinamida.',
  'seo.productTitle.smart-capsule-cream-with-collagen': 'Crema Cápsula PDRN con Colágeno | Cuidado Coreano | PDRN',
  'seo.productDescription.smart-capsule-cream-with-collagen': 'Compra la crema cápsula PDRN con colágeno y niacinamida. Crema anti-edad coreana con tecnología ADN de salmón para hidratación profunda y firmeza.',
  'seo.productTitle.complete-pdrn-trio-bundle': 'Set Completo PDRN — Sérum, Mascarillas & Crema | Cuidado Facial PDRN',
  'seo.productDescription.complete-pdrn-trio-bundle': 'Compra el set completo de cuidado PDRN con sérum, 10 mascarillas y crema. Ahorra hasta un 53% en cuidado coreano con ADN de salmón.',

  // Internal linking
  'seo.explorePDRN': 'Descubre el cuidado PDRN',
  'seo.anchor.serumBenefits': 'Beneficios del sérum PDRN',
  'seo.anchor.howPDRNWorks': 'Cómo funciona el PDRN',
  'seo.anchor.masksVsTraditional': 'Mascarillas PDRN vs tradicionales',
  'seo.anchor.glassSkinGuide': 'Guía Glass Skin',
  'seo.anchor.koreanSecret': 'El secreto coreano del cuidado',
  'seo.anchor.pdrnVsRegular': 'PDRN vs cuidado tradicional',
};
